import { render } from "./Authenticated.vue?vue&type=template&id=1d976f8f&scoped=true"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=1d976f8f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1d976f8f"

export default script